export default __webpack_public_path__ + "static/media/R_logo.a6dbdf46.png";